import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import useSingleTemplatesDataStore from 'templates/stores/singleTemplateDataStore';

import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';

import useScrollTo from 'hooks/useScrollTo';
import { usePulseSegments } from '@pulse/react';
import Navigation from './components/Navigation';
import Aside from './components/Aside';
import Content from './components/Content';
import Slider from './components/Slider';
import SingleTemplateSkeleton from './components/SingleTemplateSkeleton';

import useStyles from './style';

const SingleTemplate = () => {
  const styles = useStyles();
  const { templateId } = useParams();

  const scrollTo = useScrollTo();
  const { segments, loading: segmentsLoading } = usePulseSegments();

  const { isLoading, fetchSingleTemplateData } = useSingleTemplatesDataStore(state => ({
    isLoading: state.isLoading,
    fetchSingleTemplateData: state.fetchSingleTemplateData,
  }));

  useEffect(() => {
    scrollTo();
    if (segmentsLoading) return;
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (async () => {
      try {
        await fetchSingleTemplateData(templateId, segments);
      } catch (err) {
        window.location.href = '/not-found';
      }
    })();
  }, [templateId, segments]);

  if (isLoading) {
    return <SingleTemplateSkeleton />;
  }

  return (
    <HorizontalContainer
      className={styles.mainLayout}
      dataTestId="horizontal-container"
      data-pulse-section-group="TemplateAssetPage"
    >
      <Navigation />
      <main className={styles.wrapper}>
        <Slider />
        <Aside />
        <Content />
      </main>
    </HorizontalContainer>
  );
};

export default SingleTemplate;
